<div class="page-body">
  <div *ngIf="internalServerError" class="error-wrapper">
    <div class="contents-container">
      <h3 class="general-error-text">Etwas ist schief gelaufen.</h3>
      <p class="info-text">
        Bitte versuchen Sie es erneut. Kontaktieren Sie uns, wenn das Problem
        weiterhin besteht.
      </p>
    </div>
  </div>

  <div *ngIf="loading && !internalServerError">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && !internalServerError" class="contents-wrapper">
    <div class="contents-container">
      <h1 class="heading">SEPA Bankeinzug</h1>

      <p class="info-text">
        Das Lastschriftverfahren ist eine sichere und bequeme Möglichkeit, Ihre
        Rechnungen automatisch zu&nbsp;bezahlen.
      </p>

      <p class="sub-heading">{{ subHeadingText }}</p>

      <div *ngIf="ibanFetchLoading">
        <app-spinner></app-spinner>
      </div>

      <form [formGroup]="form" *ngIf="!ibanFetchLoading">
        <div formControlName="iban" ngDefaultControl>
          <app-expandable-list-item
            *ngFor="let iban of ibans"
            [title]="ibanFormatter(iban)"
            [color]="color"
            [selected]="iban === selectedIban"
            [isFirstItem]="iban === ibans[0]"
            [isLastItem]="iban === ibans[ibans.length - 1]"
            [hideSelectButton]="ibans.length === 1"
            [hideBulletPoints]="true"
            [textOverTitle]="'IBAN'"
            (click)="selectIban(iban)"
          ></app-expandable-list-item>
        </div>
      </form>

      <p class="sub-info-text">
        Wenn Sie auf "Bestätigen" klicken, ermächtigen Sie Frink AB (Zaver),
        Anweisungen an Ihre Bank zu senden, um Ihr Konto gemäß dem
        Sepa-Lastschriftmandat zu belasten.<br />
        <a class="terms-btn" (click)="openModalWithTerms()">
          Bedingungen ansehen
        </a>
      </p>

      <zaver-checkout-modal
        *ngIf="modalActive"
        [buttonText]="'Schließen'"
        [logo]="'assets/img/Zaver_Logotype_Circle_Coal_DE.svg'"
        (onClose)="deactivateModal()"
      >
        <app-selector
          #selector
          *ngIf="!!selectoritems"
          [selectorItems]="selectoritems"
          [selectedItem]="selectoritems[2]"
        ></app-selector>
      </zaver-checkout-modal>

      <div class="footer-wrapper">
        <div class="footer-container">
          <div class="button-container">
            <zaver-primary-button
              [text]="'Bestätigen'"
              [disabled]="navigationInProgress || !validateIbanSelected()"
              (click)="handleCtaClick()"
            ></zaver-primary-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
